import { Link } from 'react-router-dom';
import { useTk } from '@/lib/i18n';

export function NotFoundPage(): React.ReactElement {
  const tk = useTk();
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-6 space-y-4 text-center">
      <p className="text-4xl">404</p>
      <p className="text-sm text-[var(--tg-hint)]">{tk('common.error.generic')}</p>
      <Link to="/" className="text-[var(--tg-link)] underline">
        {tk('nav.home')}
      </Link>
    </main>
  );
}
